<app-loader *ngIf="removeUserFromBrigadeLoading"></app-loader>
<div class="modal__header">
  <span class="title">Удаление бригадира из бригады</span>
  <div class="modal-close color-gray-dark" (click)="activeModal.dismiss()" id="appCloseXRemoveUser"></div>
</div>
<div class="modal__body">
  Удалить сотрудника из бригады можно только при увольнении. Бригадир
  {{ user.employee.full_name }} будет удален из бригады {{ currentBrigade.brigade_name }}.

  <div class="mt-16">
    <app-field>
      <label>Новый бригадир в текущей бригаде</label>
      <app-combobox
        [items]="brigadeHeadListInBrigade"
        (callback)="onChangeSelectedNewBrigadeHead($event)"
        [textKey]="'full_name'"
        [defaultText]="'Выберите бригадира'"
        [initBy]="brigadeHeadNewSelected"
        [name]="'newBrigadeHead'"
      ></app-combobox>
    </app-field>
  </div>

  <div class="mt-16" *ngIf="errorMessage">
    <app-message [type]="'error'">
      <div message-content>
        {{ errorMessage }}
      </div>
    </app-message>
  </div>
</div>
<div class="modal__footer">
  <div class="modal__footer-action">
    <button class="button" type="button" [disabled]="!brigadeHeadNewSelected" (click)="onRemoveUserFromBrigade()" id="appRemoveUser">Удалить</button>
  </div>
  <div class="modal__footer-action">
    <a class="link link--dotted-blue-dark" (click)="activeModal.dismiss()" id="appCloseRemoveUser"> Отмена </a>
  </div>
</div>
